import {Observable} from 'rxjs';
import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Address, B2BUnit, OccEndpointsService} from "@spartacus/core";
import { GonvarriB2BUnit } from '../models/gonvarri-b2b-unit.model';

@Injectable({
  providedIn: 'root'
})
export class GonvarriMyCompanyAddressesAdapter {

  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService
  ) {}

  public getAddresses(): Observable<GonvarriB2BUnit> {
    return this.http
      .get<GonvarriB2BUnit>(
        this.getAddressBookUrl(),
        {}
      )
  }

  public defineDefaultAddress(address: Address): Observable<Address> {
    return this.http
      .get<Address>(
        this.getDefineDefaultAddressUrl(address),
        {}
      )
  }

  private getAddressBookUrl(): string {
    const queryParams = {}
    return this.occEndpointsService.buildUrl(`/my-company/organization-management/address-book`, {
      queryParams
    })
  }

  private getDefineDefaultAddressUrl(address: Address): string {
    const queryParams = {};
    return this.occEndpointsService.buildUrl(`/my-company/organization-management/set-default-address/${address.id}`,  {
      queryParams
    })
  }

}
